// extracted by mini-css-extract-plugin
export var background = "masterPlan-module--background--lPHDe";
export var buttonContainer = "masterPlan-module--buttonContainer--j1ppr";
export var heading = "masterPlan-module--heading--UWSkO";
export var image = "masterPlan-module--image--9ZEhS";
export var section = "masterPlan-module--section---eBhA";
export var show = "masterPlan-module--show--qNB-t";